// One calibration per source image, independent of bike or drivetrain name.
// Database coordinates remain in source-image pixels; colour overrides are
// resolved by itemProps before these adapters read them.
const road = (asset, x, y, width, height) => ({
  image: `/resources/groupsets/ccache/${asset}-lever.png`,
  origin: { x, y }, width, height, scale: .29, rotation: -8 * Math.PI / 180
});
const levers = {
  '/resources/groupsets/newleverred2025.png': road('sram-red', 64, 179, 312, 386),
  '/resources/groupsets/1manetaforcev5.png': road('sram-force', 63, 176, 293, 379),
  '/resources/groupsets/1-maneta-dura-1v2.png': road('shimano-dura-ace', 68, 173, 324, 397),
  // Force road and XPLR use the same shift/brake body; share its image-space contact.
  '/uploads/framesets/frameset-1783628129492.png': road('sram-force', 63, 176, 293, 379),
  // The Ergopower photo is shot nose-up and smaller than the CCACHE levers:
  // seat its lower rear cuff on the bar like SRAM/Shimano, pitch it forward.
  '/resources/groupsets/1manetacampyv4.png': {
    origin: { x: 225, y: 232 }, width: 330, height: 460, scale: .6, rotation: -8 * Math.PI / 180
  }
};

export function cockpitPoint(props, prefix) {
  return { x: props[prefix + 'X'] ?? 0, y: props[prefix + 'Y'] ?? 0 };
}

// Lower-cuff contacts measured against the top of each source bar silhouette.
// Match the previous point as well as the image so later admin edits survive.
const barContacts = {
  '/uploads/framesets/frameset-1783606522927.png': { from: [370, 82], to: [370, 112] },
  '/uploads/framesets/frameset-1783610322084.png': { from: [399, 98], to: [399, 133] },
  '/resources/bars/2zippcockpit2.png': { from: [403, 68], to: [403, 98] },
  '/resources/bars/lightweightcockpit.png': { from: [395, 75], to: [395, 100] },
  '/resources/bars/alanera.png': { from: [385, 85], to: [385, 105] },
  '/uploads/framesets/frameset-1783606521546.png': { from: [402, 64], to: [402, 96] }
};

export function handlebarLeverPoint(image, props) {
  const point = cockpitPoint(props, 'groupsetBar'), fit = barContacts[image];
  if (fit && point.x === fit.from[0] && point.y === fit.from[1])
    return { x: fit.to[0], y: fit.to[1] };
  return point;
}

export function handlebarLayer(base, props, frame) {
  return {
    ...base,
    origin: { x: props.originX, y: props.originY },
    scale: props.renderScale > 0 ? props.renderScale : base.scale,
    rotation: (frame.inclinationFront || 0) * Math.PI / 180
  };
}

export function leverLayer(base, image, frameScale = 1) {
  const fit = levers[image];
  const layer = { ...base, type: 'groupsetsBar', anchor: 'groupsetsBar', index: 7,
    image, origin: {}, scale: .45 * frameScale, rotation: 0 };
  // Unknown artwork keeps the catalogue image and its centred legacy origin.
  if (!fit) return layer;
  return { ...layer, image: fit.image || image, origin: { ...fit.origin },
    scale: fit.scale * frameScale, rotation: fit.rotation,
    renderWidth: fit.width, renderHeight: fit.height };
}
